<i18n>
{
  "en": {
    "edit": "Edit event type",
    "delete": "Delete event type",
    "positive": "Positive influence",
    "negative": "Negative influence"
  },
  "es": {
    "edit":  "Editar tipo de evento",
    "delete":  "Eliminar tipo de evento",
    "positive": "Influencia positiva",
    "negative": "Influencia negativa"
  }
}
</i18n>
<template>
  <dynameat-row
    :title="eventType.name"
    :description="eventType.description"
    :button-config-list="buttonConfigList"
    :collapse-items="!$vuetify.breakpoint.mdAndUp"
    @editEventType="onEditEventType"
    @deleteEventType="onDeleteEventType"
    :isClickable="false"
  >
    <template v-slot:rowIconsRight>
      <v-row align="center" class="chip-top">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="eventType.isPositive" icon class="mr-3" v-on="on" v-bind="attrs">
              <v-icon
                :color="eventType.color">
                mdi-thumb-up
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('positive') }}</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="!eventType.isPositive" icon class="mr-3" v-on="on" v-bind="attrs">
              <v-icon
                :color="eventType.color">
                mdi-thumb-down
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('negative') }}</span>
        </v-tooltip>
      </v-row>
    </template>
  </dynameat-row>
</template>
<script>
import DynameatRow from '@dynameat/components/DynameatRow';
import Component from 'vue-class-component';
import { Components, MapGetters } from '@core/helpers/decorators';
import { Prop } from 'vue-property-decorator';
import { EventType } from '@eventManager/models';
import Vue from 'vue';

@Component
@Components({ DynameatRow })
export default class EventTypeRow extends Vue {
  @Prop({
    Object,
    validator(eventType) {
      return eventType instanceof EventType;
    }
  }) eventType;

  get buttonConfigList() {
    return [
      {
        title: this.$t('edit'),
        icon: 'mdi-pencil',
        emitName: 'editEventType',
      },
      {
        title: this.$t('delete'),
        icon: 'mdi-delete',
        emitName: 'deleteEventType',
      }
    ];
  }

  onEditEventType() {
    this.$emit('edit');
  }

  onDeleteEventType() {
    this.$emit('delete');
  }
}
</script>
<style>
.v-list-item__subtitle {
  white-space: normal;
}
</style>
<style scoped lang="scss">
.chip-top {
  margin-top: 0;
  margin-left: 0;
}

.chip {
  margin-top: 5px;
  margin-right: 5px;
}
</style>
